import { config } from '../config/app.config';
import apiClient from '../clients/apiClient';
import { ApiResponse } from '../schemas/apiResponseSchema';
import { Schemas } from '../types/api-types';

export type PlAccountType = Schemas['PlAccountType'] | any;

export async function getPlInvestmentTypes(): Promise<PlAccountType[]> {
    try {
        const response = await apiClient.get<ApiResponse<PlAccountType[]>>('/pl_account_type/all', { params: { category_id: config.investmentCategoryId } });
        return response.data.data || [];
    } catch (error: any) {
        if (error.response?.status === 401) {
            throw new Error('Please login again to continue');
        }
        if (error.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }
        if (error.message) {
            throw new Error(error.message);
        }
        throw new Error('Failed to fetch PL account types');
    }
}

export async function getPlEquipmentsTypes(): Promise<PlAccountType[]> {
    try {
        const response = await apiClient.get<ApiResponse<PlAccountType[]>>('/pl_account_type/all', { params: { category_id: config.equipmentCategoryId } });
        return response.data.data || [];
    } catch (error: any) {
        if (error.response?.status === 401) {
            throw new Error('Please login again to continue');
        }
        if (error.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }
        if (error.message) {
            throw new Error(error.message);
        }
        throw new Error('Failed to fetch PL account types');
    }
}

export async function getPlDebtorsTypes(): Promise<PlAccountType[]> {
    try {
        const response = await apiClient.get<ApiResponse<PlAccountType[]>>('/pl_account_type/all', { params: { category_id: config.debtorsCategoryId } });
        return response.data.data || [];
    } catch (error: any) {
        if (error.response?.status === 401) {
            throw new Error('Please login again to continue');
        }
        if (error.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }
        if (error.message) {
            throw new Error(error.message);
        }
        throw new Error('Failed to fetch PL account types');
    }
}

export async function getPlCreditorsTypes(): Promise<PlAccountType[]> {
    try {
        const response = await apiClient.get<ApiResponse<PlAccountType[]>>('/pl_account_type/all', { params: { category_id: config.creditorsCategoryId } });
        return response.data.data || [];
    } catch (error: any) {
        if (error.response?.status === 401) {
            throw new Error('Please login again to continue');
        }
        if (error.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }
        if (error.message) {
            throw new Error(error.message);
        }
        throw new Error('Failed to fetch PL account types');
    }
}

export type PlAccountTypeCategory = {
    id: number;
    category_name: string;
    status: number;
};

export async function getAccountTypeCategories(): Promise<PlAccountTypeCategory[]> {
    try {
        const response = await apiClient.get<ApiResponse<PlAccountTypeCategory[]>>('/pl_account_type/categories');
        return response.data.data || [];
    } catch (error: any) {
        if (error.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }
        throw new Error('Failed to fetch categories');
    }
}
